import React, { useEffect, useRef } from 'react';
import H5PStandalone from 'h5p-standalone';

type Props = {
  contentBaseUrl: string;
  height?: number | string;
};

function normalizeBaseUrl(url: string) {
  return new URL(url).toString().replace(/\/$/, '');
}

export function H5pPlayer({ contentBaseUrl, height = 600 }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    el.innerHTML = '';

    const H5P =
      (H5PStandalone as any).H5P || (H5PStandalone as any).default?.H5P;

    if (!H5P) {
      console.error('H5P constructor not found');
      return;
    }

    const base = normalizeBaseUrl(contentBaseUrl);

    const instance = new H5P(el, {
      h5pJsonPath: base,
      contentJsonPath: `${base}/content`,
      assetsRequestFetchOptions: {
        credentials: 'include',
      },
    });

    return () => {
      el.innerHTML = '';
      if ((instance as any)?.destroy) (instance as any).destroy();
    };
  }, [contentBaseUrl]);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        minHeight: typeof height === 'number' ? `${height}px` : height,
      }}
    />
  );
}
